import React from "react";
import { color } from "../../styles/theme";

/**
 * Underline tab bar with an animated active indicator (CSS transform, see
 * .tab-btn in global.css). `tabs` is [{ key, label, icon? }].
 */
const Tabs = ({ tabs, active, onChange }) => (
  <div style={s.row}>
    {tabs.map((t) => (
      <button
        key={t.key}
        type="button"
        className={`tab-btn${active === t.key ? " active" : ""}`}
        onClick={() => onChange(t.key)}
        style={s.btn}
      >
        {t.icon && <t.icon size={15} strokeWidth={2.25} style={{ marginRight: 6, verticalAlign: -3 }} />}
        {t.label}
        <span className="tab-indicator" />
      </button>
    ))}
  </div>
);

const s = {
  row: { display: "flex", gap: 22, marginBottom: 22, borderBottom: `1px solid ${color.border}` },
  btn: { display: "inline-flex", alignItems: "center" },
};

export default Tabs;
